<script lang="ts">
    let className: string = "";
    export {className as class};
    export let style: string = "";
</script>

<svg
        {style}
        class={className} 
   width="23.916666"
   zoomAndPan="magnify"
   viewBox="0 0 17.9375 16.945624"
   height="22.594166"
   preserveAspectRatio="xMidYMid meet"
   version="1.0"
   id="svg830"
   sodipodi:docname="Edit the road network(5).svg"
   inkscape:version="1.1.1 (c3084ef, 2021-09-22)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs834" />
  <sodipodi:namedview
     id="namedview832"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     showgrid="false"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0"
     inkscape:zoom="0.10689466"
     inkscape:cx="-664.20531"
     inkscape:cy="-304.03764"
     inkscape:window-width="1920"
     inkscape:window-height="967"
     inkscape:window-x="0"
     inkscape:window-y="25"
     inkscape:window-maximized="1"
     inkscape:current-layer="svg830" />
  <path
     fill="#f9fbfd"
     d="M 0,0.75 C 0,0.54297 0.0703,0.36719 0.21875,0.21875 0.36329,0.07422 0.53907,0 0.7461,0 h 16.44531 c 0.20703,0 0.38281,0.0742 0.52734,0.21875 0.14844,0.14844 0.21875,0.32422 0.21875,0.53125 0,0.20313 -0.0703,0.37891 -0.21875,0.52735 -0.14453,0.14453 -0.32031,0.21875 -0.52734,0.21875 h -0.25 v 8.71875 c 0,0.36718 -0.0664,0.71484 -0.20703,1.05078 -0.14063,0.33593 -0.33594,0.63281 -0.59375,0.89062 -0.25781,0.25391 -0.55469,0.45313 -0.89063,0.59375 -0.33593,0.13672 -0.68359,0.20703 -1.04687,0.20703 h -1.07031 l 0.79687,3.05078 c 0.0508,0.19922 0.0234,0.38672 -0.0781,0.56641 -0.10547,0.17969 -0.25782,0.29297 -0.45703,0.34375 -0.19922,0.0547 -0.39063,0.0273 -0.56641,-0.0742 -0.17969,-0.10547 -0.29297,-0.25781 -0.34766,-0.45703 l -0.11328,-0.4375 H 5.57034 l -0.11328,0.4375 C 5.40626,16.58596 5.28909,16.7383 5.1094,16.84377 4.93362,16.94533 4.74221,16.97268 4.54299,16.91797 4.34377,16.86717 4.19143,16.75391 4.08987,16.57422 3.9844,16.39453 3.95706,16.20703 4.01177,16.00781 L 4.80474,12.95703 H 3.73834 C 3.37505,12.95703 3.02349,12.88673 2.68755,12.75 2.35162,12.60938 2.05474,12.41016 1.79693,12.15625 1.54302,11.89844 1.3438,11.60156 1.20318,11.26563 1.06646,10.92969 0.99615,10.58203 0.99615,10.21485 V 1.4961 h -0.25 C 0.53912,1.4961 0.36334,1.4219 0.2188,1.27735 0.07037,1.12891 5e-5,0.95313 5e-5,0.75 Z m 6.35157,12.20703 -0.39063,1.4961 h 6.01563 l -0.39063,-1.4961 z m 7.46484,-8.90234 c 0.12109,0.16797 0.16406,0.35547 0.12891,0.55859 -0.0352,0.20313 -0.13672,0.36719 -0.30469,0.48438 -1.25,0.89453 -2.37891,1.92578 -3.38672,3.08984 C 10.11329,8.35156 9.9336,8.4375 9.71875,8.44531 9.5,8.45331 9.31641,8.37891 9.16016,8.22656 L 7.47266,6.53906 5.26172,8.75391 C 5.11719,8.90235 4.9375,8.98047 4.73047,8.98047 4.51954,8.98047 4.34375,8.91017 4.19532,8.76172 4.04688,8.61328 3.97657,8.4336 3.97657,8.22656 3.98057,8.01563 4.05467,7.83985 4.20704,7.69531 L 6.94532,4.95313 C 7.09375,4.8086 7.26954,4.73438 7.47266,4.73438 c 0.20703,0 0.38281,0.0742 0.53125,0.21875 l 1.65625,1.66015 c 0.94531,-1.01562 1.98438,-1.92578 3.11328,-2.73437 0.16797,-0.11719 0.35156,-0.16016 0.5586,-0.125 0.20312,0.0312 0.36328,0.13281 0.48437,0.30078 z m 0,0"
     fill-opacity="1"
     fill-rule="evenodd"
     id="path828" />
</svg>
